import { $themeBreakpoints } from '@themeConfig'
import RestApi, { studyPressBaseUrl } from '@/config/api_config'
// import store from '@/store'
import ModalBaseMasterList from '@core/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  computed: {
    hasDropdownLoadedCommonConfig () {
      return this.$store.state.commonObj.hasDropdownLoaded
    }
  },
  watch: {
    $route() {
      if (this.$store.state.app.windowWidth < $themeBreakpoints.xl) {
        this.isVerticalMenuActive = false
      }
    },
    hasDropdownLoadedCommonConfig: function (newValue) {
      if (!newValue) {
        this.loadDropdownCommonConfig()
      }
    }
  },
  created () {
    const hasDropdownLoadedCommonConfig = this.$store.state.commonObj.hasDropdownLoaded
    if (!hasDropdownLoadedCommonConfig || window.performance) {
      this.getAuthData()
      this.loadDropdownCommonConfig()
    }
  },
  methods: {
    loadDropdownCommonConfig () {
      RestApi.getData(studyPressBaseUrl, 'api/common-dropdowns', null).then(response => {
        if (response.success) {
          // console.log('common-dropdowns', response.data)
          // localStorage.setItem('refGroupList', JSON.stringify(response.data.refGroupList))
          // localStorage.setItem('refTextList', JSON.stringify(response.data.refTextList))
          // localStorage.setItem('activityLogList', JSON.stringify(response.data.activityLogList))
          this.$store.dispatch('mutateCommonProperties', {
            hasDropdownLoaded: true,
            refGroupList: response.data.refGroupList,
            // refTextList: response.data.refTextList,
            // questionBankList: response.data.questionBankList,
            // refDetailsList: response.data.refDetailsList,
            courseList: response.data.courseList,
            pricingList: response.data.pricingList,
            categoryPriceList: response.data.categoryPriceList,
            // activityLogList: response.data.activityLogList,
          })
        }
      })
    }
  }
}
